// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"53a3ad63","742":"abaf46bd","744":"9f6fcb7f","829":"c5773b3f","974":"ea1dea99"}[chunkId] + ".chunk.js";
};